import { Phone, Mail, MapPin, Clock } from "lucide-react";
import { SITE } from "../../data/site";

export const Footer = () => (
  <footer
    data-testid="site-footer"
    className="relative bg-[#1C1B1A] text-[#F9F7F4] pt-24 md:pt-32 pb-28 md:pb-16 grain overflow-hidden"
  >
    <div className="max-w-[1400px] mx-auto px-6 md:px-10 relative">
      {/* Massive call headline */}
      <div className="mb-16 md:mb-24">
        <div className="text-[#C05746] text-xs md:text-sm font-semibold tracking-[0.24em] uppercase mb-6">
          One call. That's it.
        </div>
        <a
          href={SITE.phoneHref}
          data-testid="footer-call-headline"
          className="block font-display text-[#F9F7F4] hover:text-[#C05746] transition-colors text-[15vw] md:text-[11vw] lg:text-[9vw] leading-[0.9] tracking-[-0.04em]"
        >
          {SITE.phoneDisplay}
        </a>
        <p className="mt-6 text-[#F9F7F4]/60 text-base md:text-lg max-w-xl">
          Real humans pick up. Fast scheduling across PA &amp; MD. No forms.
          No chat bots. No runaround.
        </p>
      </div>

      {/* NAP grid for local SEO */}
      <div className="grid grid-cols-1 md:grid-cols-4 gap-10 md:gap-8 border-t border-[#2A3B32] pt-14">
        <div>
          <div className="text-[10px] uppercase tracking-[0.24em] text-[#F9F7F4]/50 mb-3 flex items-center gap-2">
            <Phone size={12} /> Phone
          </div>
          <a
            href={SITE.phoneHref}
            className="font-display text-xl md:text-2xl hover:text-[#C05746] transition-colors"
          >
            {SITE.phoneDisplay}
          </a>
        </div>

        <div>
          <div className="text-[10px] uppercase tracking-[0.24em] text-[#F9F7F4]/50 mb-3 flex items-center gap-2">
            <Mail size={12} /> Email
          </div>
          <a
            href={SITE.emailHref}
            className="font-display text-base md:text-lg hover:text-[#C05746] transition-colors break-all"
          >
            {SITE.email}
          </a>
        </div>

        <div>
          <div className="text-[10px] uppercase tracking-[0.24em] text-[#F9F7F4]/50 mb-3 flex items-center gap-2">
            <MapPin size={12} /> Address
          </div>
          <address className="not-italic font-display text-base md:text-lg leading-snug">
            4131 Huffmanville Road
            <br />
            Glen Rock, PA 17327
          </address>
        </div>

        <div>
          <div className="text-[10px] uppercase tracking-[0.24em] text-[#F9F7F4]/50 mb-3 flex items-center gap-2">
            <Clock size={12} /> Hours
          </div>
          <p className="font-display text-base md:text-lg leading-snug">
            Mon – Sat · 7 AM – 7 PM
            <br />
            <span className="text-[#F9F7F4]/50">Closed Sunday</span>
          </p>
        </div>
      </div>

      <div className="mt-16 pt-8 border-t border-[#2A3B32] flex flex-col md:flex-row items-start md:items-center justify-between gap-4">
        <div className="flex items-center gap-3">
          <span className="w-9 h-9 flex items-center justify-center bg-[#C05746] text-[#F9F7F4] font-display text-lg">
            A
          </span>
          <span className="font-display text-sm md:text-base">
            ATC Pest Control · Family-Owned Since 1991
          </span>
        </div>
        <p className="text-xs text-[#F9F7F4]/50">
          © {new Date().getFullYear()} ATC Pest Control. All rights reserved. Licensed, trained &amp; insured in PA &amp; MD.
        </p>
      </div>
    </div>
  </footer>
);
